// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import EventTarget from '@ungap/event-target';
import { BunnyAgent } from "./bunny-agent.js";
import { BunnyDevice } from "./bunny-device.js";

export class BunnyGlobal extends EventTarget {
	protected _state: 'loading' | 'authorizing' | 'authorized' | 'revoking' | 'revoked' | 'expired' | 'error' = 'loading';
	protected _user_code?: string;
	protected _error_code = '';
	protected _verification_uri?: string;
	protected _verification_uri_complete?: string;
	protected _device?: BunnyDevice;
	protected _agents = new Map<string, BunnyAgent>();

	constructor() {
		super();
	}

	get state(): string {
		return this._state;
	}
	set state(value: 'authorizing' | 'authorized' | 'revoking' | 'revoked' | 'expired' | 'error') {
		if(value === this._state) {
			return;
		}
		console.log(`state: ${value}`);
		this._state = value;
		this.dispatchEvent(new Event('statechange'));
	}

	get user_code(): string | undefined {
		return this._user_code;
	}
	set user_code(value: string | undefined) {
		this._user_code = value;
		this.dispatchEvent(new Event('usercodechange'));
	}

	get error_code(): string {
		return this._error_code;
	}
	set error_code(value: string) {
		this._error_code = value;
		this.dispatchEvent(new Event('errorcodechange'));
	}

	get verification_uri(): string | undefined {
		return this._verification_uri;
	}
	set verification_uri(value: string | undefined) {
		this._verification_uri = value;
		this.dispatchEvent(new Event('verificationurichange'));
	}

	get verification_uri_complete(): string | undefined {
		return this._verification_uri_complete;
	}
	set verification_uri_complete(value: string | undefined) {
		this._verification_uri_complete = value;
		this.dispatchEvent(new Event('verificationuricompletechange'));
	}

	get device(): BunnyDevice | undefined {
		return this._device;
	}
	set device(value: BunnyDevice | undefined) {
		this._device = value;
		this.dispatchEvent(new Event('devicechange'));
	}

	get agents(): Map<string, BunnyAgent> {
		return this._agents;
	}

	async revokeToken(): Promise<void> {
		if(!this._device) {
			throw new Error('No device');
		}
		window.dsbunny.rmm.state = 'revoking';
		await this._device.revokeRefreshToken();
		window.dsbunny.rmm.state = 'revoked';
	}
}
